import React from 'react'
import './Chy.css';
// import { Card } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
  FireTwoTone
} from '@ant-design/icons';
import { Link} from "react-router-dom";
import { Layout, Menu, theme } from 'antd';
import Logo from '../Images/LOGO2 (2).gif'
import { useState } from 'react';
import {  Table } from 'antd';

const { Header, Sider, Content } = Layout;
// const { Meta } = Card;

const columns = [
    {
      title: 'Years',
      dataIndex: 'years',
      key: 'Years',
    //   render: (text) => <>{text}</>,
    },
    {
      title: 'Question Paper',
      dataIndex: 'links',
      key: 'Question Paper',
      render: (data) => <a href={data}>Chemistry</a>,
    },
    {
      title: 'Answers',
      dataIndex: 'ans',
      key: 'Answers',
      render: (text) => <a href={text}>Solution</a>,
    },
  ];
  const data = [
    {
      years: '2019-20',
      qpaper: 'Computer Programming',
      answers: 'Solution',
      links:'https://drive.google.com/file/d/184Le8-33Tc_cpqjHfQjncKMQkRfC-zce/view?usp=sharing',
      ans:'https://docs.google.com/document/d/1YlEARjpAigN9BuaqaUYzqUI2rIZHkjQA1hDLBcxDeGc/edit?usp=sharing'
    },
    {
      years: '2019-20 Mid Term',
      qpaper: 'Computer Programming',
      answers: 'Solution',
      links:'https://drive.google.com/file/d/1LmzWRYbb1cVSFYGK1-c32im6k1k1QJBl/view?usp=share_link',
      ans:'https://docs.google.com/document/d/1YlEARjpAigN9BuaqaUYzqUI2rIZHkjQA1hDLBcxDeGc/edit?usp=sharing'
    },
    {
      years: '2020-21',
      qpaper: 'Computer Programming',
      answers: 'Solution',
      links:'https://drive.google.com/file/d/1Zw-G9cOFXPqFAWWr1qfCu6KZwMwA3qSf/view?usp=sharing',
      ans:'https://docs.google.com/document/d/17gnHqwR-L-o5Zu9YHAa0NEhg62na9ul-tNGEPEesxTM/edit?usp=sharing'
    },
    {
      years: '2020-21 Mid Term',
      qpaper: 'Computer Programming',
      answers: 'Solution',
      links:'https://drive.google.com/file/d/1qTZuTtyfpBWdTEw01kd6rrvLL64bh8Iq/view?usp=share_link',
      ans:'https://docs.google.com/document/d/17gnHqwR-L-o5Zu9YHAa0NEhg62na9ul-tNGEPEesxTM/edit?usp=sharing'
    },
    {
      years: '2021-22',
      qpaper: 'Computer Programming',
      answers: 'Solution',
      links:'https://drive.google.com/file/d/1nSU-kOdObysN6uTDGfKft1q9bPc-XAju/view?usp=sharing',
      ans:'https://docs.google.com/document/d/1o2jzjk259QsnBBlL0YJbL2jn-cw1JPvd/edit'
    },
  ];

function Chy() {

    const [collapsed, setCollapsed] = useState(false);
    const {
        token: { colorBgContainer },
    } = theme.useToken();

  return (
    <Layout  >
    <Sider trigger={null} collapsible collapsed={collapsed}>
    <Link to='/' style={{}}>
                <div className="logo" style={{height:80,width:170}}>
                    <img src={Logo} alt="" style={{height:100,width:195,position:'absolute',left:0,top:5,borderRadius:15}}/>
                </div>
        </Link>
    <Menu
        theme="dark"
        mode="inline"
        // defaultSelectedKeys={['1']}
        items={[
          {
          key: '1',
          icon: <UserOutlined />,
          label:(
              <Link to='https://surveyheart.com/form/640b8371c803e1092adf4ba1'>
                Feedback
              </Link>
              
            ), 
          },
          {
          key: '2',
          icon: <FireTwoTone />,
          label: (
              <Link to='/about'>
                About Us
              </Link>
              
            ),
          }
         
      ]}
    />
    </Sider>
    <Layout className="site-layout">
    <Header
        style={{
        padding: 0,
        background: colorBgContainer,
        }}
    >
        {/* {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
        className: 'trigger',
        onClick: () => setCollapsed(!collapsed),
        })} */}
    </Header>
    <Content
        style={{
        margin: '24px 16px',
        padding: 24,
        minHeight: 680,
        background: colorBgContainer,
        }}
    >
        <Table columns={columns} dataSource={data} />
        {/* <Table columns={columns} dataSource={data} /> */}
    </Content>
    </Layout>
    </Layout>
  )
}

export default Chy